import { Card, CardBody, type CardHandle } from '@progress/kendo-react-layout'
import React from 'react'

import { Typography } from '~/components/elements/Typography'
import { exists } from '~/utils'

export type PopoverLinkProps = {
  anchorElement: HTMLAnchorElement
}

export const PopoverLink = ({ anchorElement }: PopoverLinkProps) => {
  const [cardWidth, setCardWidth] = React.useState<number | undefined>(
    undefined,
  )
  const handleRef = React.useCallback<React.RefCallback<CardHandle>>((card) => {
    setCardWidth(card?.element?.offsetWidth)
  }, [])
  const style = React.useMemo(() => {
    const frameElementRect =
      anchorElement?.ownerDocument.defaultView?.frameElement?.getBoundingClientRect()
    const frameBodyScrollTop = anchorElement?.ownerDocument.body.scrollTop
    if (
      !exists(anchorElement) ||
      !exists(frameElementRect) ||
      !exists(frameBodyScrollTop) ||
      !exists(cardWidth)
    ) {
      return undefined
    }

    const top =
      frameElementRect.top +
      anchorElement.offsetTop +
      anchorElement.offsetHeight +
      4 -
      frameBodyScrollTop
    const left =
      Math.min(
        frameElementRect.left + anchorElement.offsetLeft,
        frameElementRect.right - cardWidth,
      ) - 4

    return { top, left, position: 'fixed' }
  }, [anchorElement, cardWidth])

  return (
    <Card ref={handleRef} style={style}>
      <CardBody>
        <a href={anchorElement.href} rel="noopener noreferrer" target="_blank">
          <Typography variant="link3">{anchorElement.href}</Typography>
        </a>
      </CardBody>
    </Card>
  )
}
